import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { SearchPageNames, CustomEvents, DialogPageNames, PageNames } from 'ep-bt-controls';
import { EpButtonStyle, EpButtonSize, EpEventService } from '@epicor/kinetic';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { NavigationExtras } from '@angular/router';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaCustomerSearchComponent } from '../epbt-fa-customer-search/epbt-fa-customer-search.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-new-quick-order-product',
  templateUrl: './epbt-fa-new-quick-order-product.component.html',
  styleUrls: ['./epbt-fa-new-quick-order-product.component.scss']
})
export class EpbtFaNewQuickOrderProductComponent implements OnInit {

  EpButtonStyle = EpButtonStyle;
  EpButtonSize = EpButtonSize;

  @Output() selectProductSearch = new EventEmitter<any>();
  @Output() productChange = new EventEmitter<any>();
  @ViewChild(EpbtFaCustomerSearchComponent, { static: false }) searchComponent: EpbtFaCustomerSearchComponent;

  productPageName: string = SearchPageNames.QuickOrderProduct;
  productSearchString: string;
  productPlaceholder = 'Search Products';
  pageNames = PageNames;

  receiveProductString($event) {
    this.productSearchString = $event;
  }

  constructor(private productService: EpbtFaProductService,
    public quickOrderService: EpbtFaQuickOrderService, public epEvent: EpEventService,
    private sortService: EpbtFaSortService, private client: FieldAgentClient, private faService: EpbtFieldAgentService) {
    this.epEvent.onEvents([CustomEvents.QuickOrderProduct]).subscribe(event => {
      if (this.quickOrderService.isNewOrder) {
        console.log(event.data);
      }
    });
  }

  ngOnInit() {
  }

  onSearchEnterClick() {
    // this.productSearchString = event.data ? event.data : "";
    this.sortService.customerSearchValue = this.productSearchString;
    this.onSearchProductClick('');
  }

  onSearchProductClick(event: any) {
    const searchString = this.productSearchString;
    this.productService.searchString = searchString;
    this.selectProductSearch.emit({ dialog: DialogPageNames.ProductSearch, searchString: searchString });
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'searchString': searchString
      }
    };
    this.productService.fromPage = PageNames.QuickOrderProductSearch;
    this.quickOrderService.AddOrEdit = true;
  }

  onSearchProductButtonClick(event: any) {
    this.selectProductSearch.emit({ dialog: DialogPageNames.ProductSearch, searchString: this.productSearchString ? this.productSearchString : '' });
    this.productService.fromPage = PageNames.QuickOrderProductSearch;
    this.quickOrderService.AddOrEdit = true;
  }

  updateSearchValue(searchValue = '') {
    this.searchComponent.updateSearchValue(searchValue);
  }
}
